import React from 'react';
import { _ApplicationStatusChange, _StatusText } from "./style";
export default function ApplicationStatus(_ref) {
  var row = _ref.row;
  return /*#__PURE__*/React.createElement(_ApplicationStatusChange, null, /*#__PURE__*/React.createElement(_StatusText, null, row.status));
}